import React from 'react';
import ReactRevealText from "react-reveal-text";
import portraitPath from "../../../assets/img/about.png";
class SkillsDescription extends React.Component {
    constructor() {
        super();
        this.state = { show: false };
    }
    componentDidMount() {
        setTimeout(() => {
            this.setState({ show: true });
        }, 100);
    }
    render() {
        return (
            <section className="section-c skills-description-section">
                <ReactRevealText className="reveal-title" show={this.state.show} text="About Me" />
                <div className="content-wrapper">
                    <div className="details-wrapper">
                        <h2>I am a Full-stack Web Developer and UI/UX Designer based in Bucharest, Romania.</h2>
                        <p>
                            Motivated Computer Science graduate, fiercely passionate about programming, continuously tracking the latest trends in information technology.
<br />
                            Full-stack web developer who focuses on writing well-structured and highly efficient code.
<br />
                            UI/UX designer striving for maximizing the user experience and creating appealing interface designs.

                        </p>
                    </div>
                    <div className="portrait-wrapper">
                        <img src={portraitPath} alt="About Me Portrait" />
                    </div>
                </div>
            </section>
        );
    }
}

export default SkillsDescription;


// WEBPACK FOOTER //
// ./src/components/skills/Description/index.js